const possibleSliders: SliderType[] = [
  { id: 'member-details', label: 'Member Details' },
  { id: 'medical-history-summary', label: 'Medical History Summary' },
  {
    id: 'prescription',
    label: 'Prescription View',
  },
  {
    id: 'report',
    label: 'Report View',
  },
  {
    id: 'np-notes',
    label: 'Internal NP Notes',
  },
];

export type SliderType = {
  id: string;
  label: string;
};

interface SlidersToInclude {
  [key: string]: string[];
}

const getSlidersToInclude = (tab: string, includeMHS: boolean) => {
  const innerTabsForTab: SlidersToInclude = {
    referrals: ['member-details', 'medical-history-summary', 'np-notes'],
    consultations: ['member-details', 'medical-history-summary', 'report', 'np-notes'],
    prescriptions: ['member-details', 'medical-history-summary', 'prescription', 'np-notes'],
  };
  const slidersToInclude = innerTabsForTab[tab] || [];
  return slidersToInclude.filter((sliderToInclude: string) =>
    !includeMHS ? sliderToInclude !== 'medical-history-summary' : sliderToInclude,
  );
};

export const makeSliders = (tab: string, includeMHS: boolean): Array<SliderType | undefined> => {
  const slidersToInclude = getSlidersToInclude(tab, includeMHS);
  return (
    slidersToInclude
      .map((sliderToInclude: string) => possibleSliders.find(({ id }) => id === sliderToInclude))
      .filter((sliderToInclude: SliderType | undefined) => !!sliderToInclude) || []
  );
};
